import React from 'react';
import useOrganizationAllowedMedicalProfileUsage from '../../../../../../hooks/api/useOrganizationAllowedMedicalProfileUsage';
import { getIntl } from '../../../../../../utils/intl';
import { ActionButtonLayout } from '../../../../../v2BaseComponents/ActionButtonLayout';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import Stack, { contentStackSpacing } from '../../../../../v2BaseComponents/Stack';
import Text from '../../../../../v2BaseComponents/Text';
import { salesEmail } from '../../../../../../utils/constants';
import MainContentContainer from '../../../../../v2BaseComponents/MainContentContainer';
import Button from '../../../../../v2BaseComponents/Button';
import * as Linking from 'expo-linking';

const intl = getIntl('FreeTierContent', {
    header: 'Free Tier',
    description: 'You are currently on the free tier. You are using {current} out of {max} clients.',
    increase: 'To upgrade your plan and increase the number of clients you can use, please contact us.',
    contactUs: 'Contact Us',
    emailSubject: 'Primary Record Professional Inquiry',
    emailBody: 'Hello, I am interested in learning more about your services.',
});

export type FreeTierContentOwnProps = {};

export type FreeTierContentProps = FreeTierContentOwnProps;

const FreeTierContent: React.FC<FreeTierContentProps> = () => {
    const { isLoading, allowedProfileUsage } = useOrganizationAllowedMedicalProfileUsage();

    return (
        <AnimateLoadedContent isLoading={isLoading}>
            {() =>
                allowedProfileUsage?.type !== 'limited' ? null : (
                    <ActionButtonLayout scrollable whiteBackground>
                        <MainContentContainer>
                            <Stack vertical space={contentStackSpacing} align="center">
                                <Text variant="h4">{intl('header')}</Text>
                                <Text variant="body-1">
                                    {intl('description', {
                                        current: allowedProfileUsage.currentMedicalProfileCount,
                                        max: allowedProfileUsage.maxAllowedMedicalProfileCount,
                                    })}
                                </Text>
                                <Text variant="body-1">{intl('increase')}</Text>
                                <Button
                                    size="sm"
                                    title={intl('contactUs')}
                                    onPress={() => {
                                        Linking.openURL(
                                            `mailto:${salesEmail}?subject=${encodeURIComponent(
                                                intl('emailSubject'),
                                            )}&body=${encodeURIComponent(intl('emailBody'))}`,
                                        ).catch(() => {
                                            console.error('Failed to open email');
                                        });
                                    }}
                                    testID="org-billing-contact-us-button"
                                />
                            </Stack>
                        </MainContentContainer>
                    </ActionButtonLayout>
                )
            }
        </AnimateLoadedContent>
    );
};

export default React.memo(FreeTierContent);
